export const POSTER_TOKEN_KEY = "apiToken";
export const ACCOUNT_URL_KEY = "accountUrl";
export const POSTER_USER_KEY = "posterUserJson";

/**
 * @returns {string | null}
 */
export function getPosterToken() {
  return (
    localStorage.getItem(POSTER_TOKEN_KEY) ||
    localStorage.getItem("posterToken")
  );
}

/**
 * @param {string} token
 */
export function setPosterToken(token) {
  localStorage.setItem(POSTER_TOKEN_KEY, token);
}

/**
 * @returns {string}
 */
export function getAccountUrl() {
  return localStorage.getItem(ACCOUNT_URL_KEY);
}

/**
 * @param {string} accountUrl
 */
export function setAccountUrl(accountUrl) {
  if (accountUrl) {
    localStorage.setItem(ACCOUNT_URL_KEY, accountUrl);
  } else {
    localStorage.removeItem(ACCOUNT_URL_KEY);
  }
}

/**
 * @param {object} u
 */
export function setCachedPosterUser(u) {
  try {
    localStorage.setItem(POSTER_USER_KEY, JSON.stringify(u));
  } catch {
    /* ignore */
  }
}

/**
 * @returns {Record<string, unknown> | null}
 */
export function getCachedPosterUser() {
  try {
    const s = localStorage.getItem(POSTER_USER_KEY);
    return s ? /** @type {Record<string, unknown>} */(JSON.parse(s)) : null;
  } catch {
    return null;
  }
}
